import { render, staticRenderFns } from "./CaixaLista.vue?vue&type=template&id=28dd03e3&scoped=true&"
import script from "./CaixaLista.vue?vue&type=script&lang=js&"
export * from "./CaixaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd03e3",
  null
  
)

export default component.exports